
import * as utils from './utils.js';
import config from './config.js';
import * as ui from './ui.js';

import * as events from './events.js';

/**
 * Initialize the application.
 */
function init() {
  // Set design name
  config.designName = utils.getDesignName();
  // Set session id
  config.sessionid = utils.getSessionId();
  // Set page type
  config.pageType = window.settingData.pagetype;
  config.dbHost.dbApi = `/api/track.php?dt=${utils.getUix()}`;
  config.isPWA = utils.isPWA();
  // clone configuration from setting data
  config.isForceShare = window.settingData.general.forceShare || false;
  config.ShowModal = window.settingData.general.showModal || false;
  config.BodyModal = window.settingData.general.bodyModal || "";
  config.TitleModal = window.settingData.general.titleModal || "";
  config.category = window.settingData.category || "";
  if (config.userModalMessage) {
    config.BodyModal = config.userModalMessage;
  }
  config.currentSharedLink = utils.getcategoryUrl(config.category);
  config.isUserShareLinkToday = utils.getLocalStorageValue(config.sharedTodayKey) || false;
  // in case the user shared today or force share is enabled so disable share link
  // disable it for now
  // if (!config.isUserShareLinkToday || !config.isForceShare) {
  //   config.isSharedLink = true; // enable share link in case the user not shared today and not forced with another post
  //   config.isForceShare = true; // force it if it was not forced
  //   config.ShowModal = true; // start to show modal to user to share
  //   config.BodyModal = "تجربة";
  //   config.TitleModal = "تجربة";
  // }
  //settingData.general.countofattemp = 0;

  window.addEventListener("load", function () {

    utils.adjustdateInputEvents();
    utils.removeGooglegscFromQuery();
    if (config.isPWA) {
      // ask the user to install the website as a mobile app 
      ui.createSubscribeModal(config.subscribeKey, config.subscribeTitle, ui.createSubscribeMessage(), utils.fireSubscribeModalAnswerEvent, utils.fireSubscribeModalRefuseEvent);
    }

  });
  //Force Full Reload on Back
  window.addEventListener("pageshow", function (event) {
    if (event.persisted) {
      window.location.reload();
    }
  });
  // Fire events callback
  events.fireEventsCallback(window.settingData);
}

// Run init
init();

